<template>
  <div dir="rtl">
    <div style="margin-top: 200px" v-if="pathLogo == m"></div>

    <div class="mlogo">
      <img class="wlogo" :src="pathLogo" />
    </div>

    <h3 style="font-size: 30px" class="text-center">{{ alldata.fullName }}</h3>
    <h3 style="font-size: 20px" class="text-center">{{ alldata.shortName }}</h3>
    <h3 class="text-center">
      كشف الحضور والإنصراف لشهر
      <b style="margin-right: 10px"> {{ convertToUi(date) }}</b>
    </h3>

    <div style="margin-top: 60px" class="container body">
      <div>ر.م</div>
      <div>الموظف</div>
      <div>رقم الموظف</div>
      <div>الوضع الحالي</div>
      <div>مجموع الغياب</div>
      <div>1</div>
      <div>2</div>
      <div>3</div>
      <div>4</div>
      <div>5</div>
      <div>6</div>
      <div>7</div>
      <div>8</div>
      <div>9</div>
      <div>10</div>
      <div>11</div>
      <div>12</div>
      <div>13</div>
      <div>14</div>
      <div>15</div>
      <div>16</div>
      <div>17</div>
      <div>18</div>
      <div>19</div>
      <div>20</div>
      <div>21</div>
      <div>22</div>
      <div>23</div>
      <div>24</div>
      <div>25</div>
      <div>26</div>
      <div>27</div>
      <div>28</div>
      <div>29</div>
      <div>30</div>
      <div>31</div>
    </div>

    <div
      :style="i % 2 == 1 ? { background: '#f5f5f5' } : { background: '#fff' }"
      v-for="(item, i) in items"
      :key="i"
      class="container"
    >
      <div>{{ i + 1 }}</div>
      <div>{{ item.employeeName }}</div>
      <div>{{ item.jobNumber }}</div>
      <div>
        {{
          item.currentSituation == 4
            ? "متفرغ"
            : item.currentSituation == 6
            ? "تدريب"
            : ""
        }}
      </div>
      <div>{{ item.totalAbsents }}</div>

      <div
        v-for="(detail, dayIndex) in item.details"
        :key="dayIndex"
        :style="getDayStyle(detail)"
      ></div>
    </div>

    <div style="direction: rtl" class="md-layout md-size-100 text-center">
      <div class="md-layout-item md-size-15 mt-25">
        <h4 class="text-left">
          <span style="background-color: #7ecf81" class="col_color"></span> =
          حضور
        </h4>
      </div>

      <div class="md-layout-item md-size-15 mt-25">
        <h4 class="text-left">
          <span
            style="background-color: rgb(236, 187, 187)"
            class="col_color"
          ></span>
          = غياب
        </h4>
      </div>

      <div class="md-layout-item md-size-15 mt-25">
        <h4 class="text-left">
          <span
            style="background-color: rgb(173, 200, 245)"
            class="col_color"
          ></span>
          = إجازة
        </h4>
      </div>

      <div class="md-layout-item md-size-15 mt-25">
        <h4 class="text-left">
          <span style="background-color: #d3d3d3" class="col_color"></span> =
          عطلة
        </h4>
      </div>

      <div class="md-layout-item md-size-15 mt-25">
        <h4 class="text-left">
          <span style="background-color: #7ecf81" class="col_color"></span> =
          تأخير
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  mounted() {},
  props: ["items", "alldata", "date", "pathLogo"],
  data() {
    return {
      currentSort: "",
      currentSortOrder: "asc",
      red: "#ecbbbb",
      blue: "#adc8f5",
      green: "#7ecf81",
      m: env.mTop(),
    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getMonth() + 1 + "-" + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    getDayStyle(detail) {
      if (!detail) return {};
      var state = detail.dayState;
      if (state == "ع") return { "background-color": "#d3d3d3" };
      if (state == "غ") return { "background-color": this.red };
      if (state == "ج") return { "background-color": this.blue };
      if (state == "ض" || state == "ت")
        return { "background-color": this.green };
      return {};
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../../assets/css/Timesheet";

.col_color {
  margin-top: 60px;
  direction: rtl;
  color: black;
  background-color: rgb(236, 187, 187);
  padding: 0px 10px 0px 10px;
  margin-left: 10px;
}
</style>